import { render, staticRenderFns } from "./EmailCapture.vue?vue&type=template&id=045884f2&scoped=true"
import script from "./EmailCapture.vue?vue&type=script&lang=js"
export * from "./EmailCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045884f2",
  null
  
)

export default component.exports